<template>
  <div>
    <footer
      id="footer"
      class="footer"
      :class="{ [`footer-${type}`]: type }"
      :data-background-color="backgroundColor"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-xs-12 col-md-3 text-center">
            <router-link class="navbar-brand" :to="'/'">
              <img
                style="max-height: 120px; max-width: 200px;"
                :src="linkLogo"
              />
            </router-link>
          </div>
          <div class="col-xs-12 col-md-7 mt-3 ">
            <div class="row">
              <div class="col-xs-12 col-md-12 d-flex justify-content-center">
                <nav>
                  <ul>
                    <li>
                      <router-link class="nav-link" :to="'/'">Home</router-link>
                    </li>
                    <li>
                      <router-link class="nav-link" :to="'/QuemSomos'"
                        >Quem Somos</router-link
                      >
                    </li>
                    <li>
                      <router-link class="nav-link" :to="'/Ajuda'"
                        >Faq</router-link
                      >
                    </li>
                    <!--li v-if="!decoded">
                  <a
                    href="javascript:void(0)"
                    class="nav-link "
                    @click="modalCadastrese = true"
                    >Cadastre-se</a
                  >
                </!--li>
                <li v-if="!decoded">
                  <a
                    href="javascript:void(0)"
                    class="nav-link "
                    @click="modalLogin = true"
                    >Entrar</a
                  >
                </li>
                <li>
                  <router-link class="nav-link" to="/TermosDeUso"
                    >Termos de Uso</router-link
                  >
                </li>
                <li>
                  <router-link class="nav-link" to="/PoliticaDePrivacidade"
                    >Política de Privacidade</router-link
                  >
                </li>
                <li-- v-if="decoded">
                  <router-link class="nav-link" to="/dashBoard"
                    >Área Interna</router-link
                  >
                </li-->
                  </ul>
                </nav>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-md-12 d-flex justify-content-center">
                <nav class="menu-redes-sociais">
                  <ul>
                    <li>Siga nas redes sociais:</li>
                    <li v-if="retornaRedesSociais('instagram')">
                      <a
                        :href="retornaRedesSociais('instagram')"
                        target="_blank"
                        class="btn btn-outline nav-link ml-1"
                        ><i class="fa-brands fa-instagram"></i
                      ></a>
                    </li>
                    <li v-if="retornaRedesSociais('telegram')">
                      <a
                        :href="retornaRedesSociais('telegram')"
                        target="_blank"
                        class="btn btn-outline nav-link ml-1"
                        ><i class="fa-brands fa-telegram"></i
                      ></a>
                    </li>
                    <li v-if="retornaRedesSociais('twitter')">
                      <a
                        :href="retornaRedesSociais('twitter')"
                        target="_blank"
                        class="btn btn-outline nav-link ml-1"
                        ><i class="fa-brands fa-twitter"></i
                      ></a>
                    </li>
                    <li v-if="retornaRedesSociais('threads')">
                      <a
                        :href="retornaRedesSociais('threads')"
                        target="_blank"
                        class="btn btn-outline nav-link ml-1"
                        ><i class="fa-brands fa-threads"></i
                      ></a>
                    </li>
                    <li v-if="retornaRedesSociais('tiktok')">
                      <a
                        :href="retornaRedesSociais('tiktok')"
                        target="_blank"
                        class="btn btn-outline nav-link ml-1"
                        ><i class="fa-brands fa-tiktok"></i
                      ></a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
          <!--div class="col-xs-12 col-md-2 text-center pt-3 deskContent">
            <div>Powered By:</div>
            <a
              href="https://queroumaloja.achadosepromocoes.com.br/"
              target="_blank"
            >
              <img :src="linkRodape" style="max-height: 100px;" />
            </a>
          </div-->
        </div>

        <div class="text-center m-3">
          &reg; {{ year }}
          {{ retornaNomeEmpresa() ? retornaNomeEmpresa() : 'Clube Certo' }}
          - Todos os direitos reservados
        </div>
        <div class="text-center m-3">
          Como participante do Programa de Associados da Amazon, recebo comissão
          pelas compras qualificadas efetuadas
        </div>
        <div class="text-center m-3">
          <img :src="require('@/assets/site-protegido.svg')" class="mr-3" />
          <img :src="require('@/assets/safe-browing.svg')" />
        </div>
        <!--div class="col-xs-12 col-md-2 text-center pt-3 phoneContent ">
          <span>Powered By:</span>
          <a
            href="https://queroumaloja.achadosepromocoes.com.br/"
            target="_blank"
            class="d-block text-center"
          >
            <img :src="linkRodape" style="height: 100px;" />
          </a>
        </div-->
        <!--div class="whats">
          <a :href="returnLinkWhats()" target="_blank">
            <img :src="require('@/assets/whatsapp-icone-2.png')"
          /></a>
        </div-->
      </div>
    </footer>
  </div>
</template>
<script>
import { Modal } from '@/components';
import storage from './../services/storage';
import service from './../services';
import { KEY_LOCAL_STORAGE } from './../const';
import tinycolor from 'tinycolor2';

export default {
  props: {
    backgroundColor: String,
    type: String,
  },
  components: {
    Modal,
  },
  data() {
    return {
      modalLogin: false,
      modalCadastrese: false,
      modalSaldo: false,
      linkLogo:
        'https://novositecbc.s3.us-east-2.amazonaws.com/assets/logo-clube-certo.webp',
      linkRodape:
        'https://novositecbc.s3.us-east-2.amazonaws.com/assets/logo-clube-certo.webp',
      year: new Date().getFullYear(),
      decoded: service.getDecoded(),
      myInterval: null,
      subscribed: null,
    };
  },
  methods: {
    retornaNomeEmpresa() {
      const logo = storage.lerStorage('nomeEmpresa');
      return logo;
    },
    retornaLinkLoja() {
      const linkLoja = storage.lerStorage('linkLoja');
      return linkLoja;
    },
    retornaLinkLogo() {
      const logo = storage.lerStorage('logo');
      return logo;
    },
    retornaRedesSociais(alvo) {
      const redesSociaisAux = storage.lerStorage('redesSociais');
      if (redesSociaisAux) {
        const redesSociais = JSON.parse(redesSociaisAux);
        return redesSociais[alvo];
      } else return null;
    },
    returnLinkWhats() {
      const celularAux = storage.lerStorage('grupoWhats');

      const celular =
        '55' +
        celularAux
          .replace('(')
          .replace(')')
          .replace(' ')
          .replace('-');
      let texto = `Olá, tudo bem?`;
      let textoEncode = encodeURI(texto);

      let link = '';
      link = `https://api.whatsapp.com/send?phone=55${celular}&text=${textoEncode}`;

      return link;
    },
    fechaModais() {
      this.modalLogin = false;
      this.modalCadastrese = false;
      this.modalSaldo = false;
    },
    finalizaBoxLogin(from) {
      this.fechaModais();
      if (from == 'Cadastro') this.modalSaldo = true;
      if (from == 'voltar') this.modalLogin = true;
    },
    getLogoRodape() {
      const tema = storage.lerStorage('tema');
      if (tema) {
        const temaCor = JSON.parse(tema);
        const cor = tinycolor(temaCor.corDeFundoDoRodape);
        if (cor.isLight())
          this.linkRodape = require('@/assets/logo-vertical-full-black.png');
        else this.linkRodape = require('@/assets/logo-vertical-full-white.png');
        this.$forceUpdate();
      }
    },
    changeLocalStorage() {
      const logo = this.retornaLinkLogo();
      if (logo) {
        this.linkLogo = logo;
      }
      this.getLogoRodape();
    },
  },
  created() {
    this.subscribed = storage.subscribe(this.changeLocalStorage);
  },

  beforeDestroy() {
    storage.unsubscribe(this.subscribed);
    clearInterval(this.myInterval);
  },
};
</script>
<style>
.formasdepagamento {
  display: block;
  clear: both;
  margin-top: 40px;
}
</style>
<style lang="scss" scoped>
.whats {
  width: 70px;
  height: 70px;
  right: 10px;
  bottom: 20px;
  padding: 10px;
  display: block;
  opacity: 0.85;
  position: fixed;
  transition: opacity 0.1s;
  visibility: visible;
  z-index: 1049;
  img {
    width: 55px;
    height: 55px;
  }
}

.whats:hover {
  opacity: 1;
}

footer {
  padding-bottom: 100px;
}
</style>
